module.exports = __webpack_public_path__ + "img/Germany.36a76654.svg";